import React, { useState } from 'react'
import Card from '../Reusable/Card'
import Button from '../Reusable/Button'
import Modal from '../Reusable/Modal'
import ChangePassword from './ChangePassword'

const CurrentUserProfile = (props: any) => {
  const { profile } = props
  const [openChangePasswordPopup, setOpenChangePasswordPopup] = useState(false);

  return (
    <>

      <Card>
        <div className='m-2'>
          <table>
            <tbody>

              <tr>
                <td>Name</td>
                <td>:</td>
                <td>{profile?.name ?? profile?.full_name ?? "N/A"}</td>
              </tr>
              <tr>
                <td>Primary Email</td>
                <td>:</td>
                <td>{profile?.user_info?.email ?? profile?.email ?? "N/A"}</td>
              </tr>
              <tr>
                <td>Secondary Email</td>
                <td>:</td>
                <td>N/A</td>
              </tr>
              <tr>
                <td>Gender</td>
                <td>:</td>
                <td>N/A</td>
              </tr>
            </tbody>

          </table>

          <div className='w-full flex justify-between'>
            <div className='w-[150px] mt-6'>
              <Button
                label={"Change Password"}
                onClick={() => setOpenChangePasswordPopup(!openChangePasswordPopup)}
              />
            </div>
          </div>
        </div>
      </Card>
      <Modal
        isOpen={openChangePasswordPopup}
        setIsOpen={setOpenChangePasswordPopup}
        title={"Change Password"}
        children={<>
          <ChangePassword
            profile={profile}
            setOpenChangePasswordPopup={setOpenChangePasswordPopup}
          />
        </>}
      />
    </>
  )
}

export default CurrentUserProfile
